import { useContext } from 'react';
import { plannerEventTypes } from '@constants/schedule';
import useCourseClassPlayer from '@hooks/useCourseClassPlayer';
import { Context as PlannerItemContext } from '@context/PlannerItemContext';
import { classDidNotHappen } from '@models/Item';
import useCheckFeatureLimit from '@cont/DeviceLimitation/useCheckFeatureLimit';
import { Spacings } from '@styles/index';
import { FeatureType } from 'types/features';
import { eventHeightMap } from '../../planner-constants';
import BaseCard from '../BaseCard';
import PlayIcon from './PlayIcon';
import PracticeBar from './PracticeBar';
import { PlannerItemWrapper } from '../PlannerElements';

const ClassCard = ({ metaItem }) => {
  const { unLiveURL, selectedGoalUID } = useContext(PlannerItemContext);

  const { open: openClassPlayer } = useCourseClassPlayer();

  let isClickable = false;
  const handleItemClick = useCheckFeatureLimit(FeatureType.CLASS, () => {
    if (!isClickable) return;
    openClassPlayer({
      lesson: metaItem,
      course: { unLiveUrl: unLiveURL, goalUID: selectedGoalUID },
      byPassCheck: true,
      forceFetch: true
    });
  });

  const {
    topicGroup,
    name,
    author,
    activityAt,
    eventType,
    isLive,
    isCancelled,
    isUpcoming,
    isSpecial,
    hasWatched,
    showIcon,
    iconColor,
    isRecordingInProgress,
    info,
    isOffline,
    isLiveStreamingEnabled,
    videoUrl
  } = metaItem;
  const isStreamingDisabled = isOffline && !isLiveStreamingEnabled;
  const isClassDidNotHappen = classDidNotHappen(metaItem);
  isClickable =
    !isUpcoming &&
    !isClassDidNotHappen &&
    !isRecordingInProgress &&
    (!isStreamingDisabled || videoUrl);

  const showMenu = !(isLive || isCancelled);
  const title = isSpecial ? 'FREE LIVE CLASS' : topicGroup?.title ?? '';
  const titleColor = topicGroup ? topicGroup.color : 'var(--color-i-black)';

  return (
    <PlannerItemWrapper $height={eventHeightMap[eventType]}>
      <BaseCard
        title={title}
        titleColor={titleColor}
        description={name}
        info={info}
        isLive={isLive}
        isCancelled={isCancelled}
        isClassDidNotHappen={isClassDidNotHappen}
        isUpcoming={isUpcoming}
        isOffline={isOffline}
        hasCompleted={hasWatched}
        author={author}
        activityAt={activityAt}
        showAuthor
        showMenu={showMenu}
        isClickable={isClickable}
        isClassCard
        isStreamingDisabled={isStreamingDisabled}
        rightIcon={
          showIcon && !isClassDidNotHappen ? (
            <PlayIcon
              color={iconColor}
              isLive={isLive}
              isRecordingInProgress={isRecordingInProgress}
              iconSize={Spacings.SPACING_6B}
            />
          ) : null
        }
        onItemClick={handleItemClick}
        item={metaItem}
        videoUrl={videoUrl}
      >
        {eventType === plannerEventTypes.CLASS_WITH_PRACTICE && (
          <PracticeBar item={metaItem} />
        )}
      </BaseCard>
    </PlannerItemWrapper>
  );
};

export default ClassCard;
